// This file is auto-generated. Do not edit directly.

import { StaticImageData } from 'next/image';

import flexhegs_nowatermark_inexpandable_png from '../public/flexhegs-nowatermark-inexpandable.png';
import image1_png from '../public/image1.png';
import image2_png from '../public/image2.png';
import image3_png from '../public/image3.png';
import image4_png from '../public/image4.png';
import image5_png from '../public/image5.png';
import image6_png from '../public/image6.png';
import image7_png from '../public/image7.png';
import image8_png from '../public/image8.png';
import image9_png from '../public/image9.png';
import image10_png from '../public/image10.png';
import image11_png from '../public/image11.png';
import image12_png from '../public/image12.png';
import image13_png from '../public/image13.png';
import image14_png from '../public/image14.png';
import image15_png from '../public/image15.png';
import image16_png from '../public/image16.png';
import image17_png from '../public/image17.png';
import image18_png from '../public/image18.png';
import image19_png from '../public/image19.png';
import image20_png from '../public/image20.png';
import image21_png from '../public/image21.png';
import image22_png from '../public/image22.png';
import image23_png from '../public/image23.png';
import image24_png from '../public/image24.png';
import hao2024_nowatermark_inexpandable_png from '../public/hao2024-nowatermark-inexpandable.png';
import ida_nowatermark_inexpandable_png from '../public/ida-nowatermark-inexpandable.png';
import new_metr_extended_nowatermark_inexpandable_png from '../public/new-metr-extended-nowatermark-inexpandable.png';
import combined_headline_inexpandable_png from '../public/combined-headline-inexpandable.png';
import epochLLMprice_nowatermark_png from '../public/epochLLMprice-nowatermark.png';
import takeoff_takeoff_timeline_inexpandable_png from '../public/takeoff/takeoff-timeline-inexpandable.png';
import combined_headline_png from '../public/combined-headline.png';
import metrhorizon_nowatermark_png from '../public/metrhorizon-nowatermark.png';
import simple_combined_headline_png from '../public/simple-combined-headline.png';
import metrsuite_nowatermark_png from '../public/metrsuite-nowatermark.png';
import metrbreakdown_nowatermark_png from '../public/metrbreakdown-nowatermark.png';
import metrrebenchsaturation_nowatermark_png from '../public/metrrebenchsaturation-nowatermark.png';
import timelines_forecast_nowatermark_png from '../public/timelines-forecast-nowatermark.png';
import metrgaps_nowatermark_png from '../public/metrgaps-nowatermark.png';
import combined_derived_png from '../public/combined-derived.png';
import combined_inputs_png from '../public/combined-inputs.png';
import updated_the_png from '../public/updated_the.png';
import updated_bag_png from '../public/updated_bag.png';
import no_inherent_super_the_png from '../public/no_inherent_super_the.png';
import no_inherent_super_bag_png from '../public/no_inherent_super_bag.png';
import no_vs_immediate_the_png from '../public/no_vs_immediate_the.png';
import no_vs_immediate_bag_png from '../public/no_vs_immediate_bag.png';
import no_vs_yes_pm_the_png from '../public/no_vs_yes_pm_the.png';
import no_vs_yes_pm_bag_png from '../public/no_vs_yes_pm_bag.png';
import neither_source_the_png from '../public/neither_source_the.png';
import neither_source_bag_png from '../public/neither_source_bag.png';
import takeoff_takeoff_timeline_png from '../public/takeoff/takeoff-timeline.png';
import epochranddflow_nowatermark_png from '../public/epochranddflow-nowatermark.png';
import einstein_png from '../public/einstein.png';
import security_FIGURE__2_png from '../public/security/FIGURE\_2.png';
import security_FIGURE__6_png from '../public/security/FIGURE\_6.png';
import security_FIGURE__7_png from '../public/security/FIGURE\_7.png';
import security_FIGURE__8_png from '../public/security/FIGURE\_8.png';
import security_FIGURE__9_png from '../public/security/FIGURE\_9.png';
import security_FIGURE__10_png from '../public/security/FIGURE\_10.png';
import security_FIGURE__1_png from '../public/security/FIGURE\_1.png';
import security_FIGURE__3_png from '../public/security/FIGURE\_3.png';
import cybench_nowatermark_png from '../public/cybench-nowatermark.png';
import security_FIGURE__11_png from '../public/security/FIGURE\_11.png';
import security_FIGURE__5_png from '../public/security/FIGURE\_5.png';
import security_FIGURE__12_png from '../public/security/FIGURE\_12.png';
import security_FIGURE__13_png from '../public/security/FIGURE\_13.png';
import goals_cotra_nowatermark_png from '../public/goals-cotra-nowatermark.png';
import goals_overview_png from '../public/goals-overview.png';
import goals_written_png from '../public/goals-written.png';
import goals_overview2_png from '../public/goals-overview2.png';
import goals_4o1_nowatermark_png from '../public/goals-4o1-nowatermark.png';
import goals_4o2_nowatermark_png from '../public/goals-4o2-nowatermark.png';

const optimizedImages: Record<string, StaticImageData> = {
  '/flexhegs-nowatermark-inexpandable.png': flexhegs_nowatermark_inexpandable_png,
  '/image1.png': image1_png,
  '/image2.png': image2_png,
  '/image3.png': image3_png,
  '/image4.png': image4_png,
  '/image5.png': image5_png,
  '/image6.png': image6_png,
  '/image7.png': image7_png,
  '/image8.png': image8_png,
  '/image9.png': image9_png,
  '/image10.png': image10_png,
  '/image11.png': image11_png,
  '/image12.png': image12_png,
  '/image13.png': image13_png,
  '/image14.png': image14_png,
  '/image15.png': image15_png,
  '/image16.png': image16_png,
  '/image17.png': image17_png,
  '/image18.png': image18_png,
  '/image19.png': image19_png,
  '/image20.png': image20_png,
  '/image21.png': image21_png,
  '/image22.png': image22_png,
  '/image23.png': image23_png,
  '/image24.png': image24_png,
  '/hao2024-nowatermark-inexpandable.png': hao2024_nowatermark_inexpandable_png,
  '/ida-nowatermark-inexpandable.png': ida_nowatermark_inexpandable_png,
  '/new-metr-extended-nowatermark-inexpandable.png': new_metr_extended_nowatermark_inexpandable_png,
  '/combined-headline-inexpandable.png': combined_headline_inexpandable_png,
  '/epochLLMprice-nowatermark.png': epochLLMprice_nowatermark_png,
  '/takeoff/takeoff-timeline-inexpandable.png': takeoff_takeoff_timeline_inexpandable_png,
  '/combined-headline.png': combined_headline_png,
  '/metrhorizon-nowatermark.png': metrhorizon_nowatermark_png,
  '/simple-combined-headline.png': simple_combined_headline_png,
  '/metrsuite-nowatermark.png': metrsuite_nowatermark_png,
  '/metrbreakdown-nowatermark.png': metrbreakdown_nowatermark_png,
  '/metrrebenchsaturation-nowatermark.png': metrrebenchsaturation_nowatermark_png,
  '/timelines-forecast-nowatermark.png': timelines_forecast_nowatermark_png,
  '/metrgaps-nowatermark.png': metrgaps_nowatermark_png,
  '/combined-derived.png': combined_derived_png,
  '/combined-inputs.png': combined_inputs_png,
  '/updated_the.png': updated_the_png,
  '/updated_bag.png': updated_bag_png,
  '/no_inherent_super_the.png': no_inherent_super_the_png,
  '/no_inherent_super_bag.png': no_inherent_super_bag_png,
  '/no_vs_immediate_the.png': no_vs_immediate_the_png,
  '/no_vs_immediate_bag.png': no_vs_immediate_bag_png,
  '/no_vs_yes_pm_the.png': no_vs_yes_pm_the_png,
  '/no_vs_yes_pm_bag.png': no_vs_yes_pm_bag_png,
  '/neither_source_the.png': neither_source_the_png,
  '/neither_source_bag.png': neither_source_bag_png,
  '/takeoff/takeoff-timeline.png': takeoff_takeoff_timeline_png,
  '/epochranddflow-nowatermark.png': epochranddflow_nowatermark_png,
  '/einstein.png': einstein_png,
  '/security/FIGURE\_2.png': security_FIGURE__2_png,
  '/security/FIGURE\_6.png': security_FIGURE__6_png,
  '/security/FIGURE\_7.png': security_FIGURE__7_png,
  '/security/FIGURE\_8.png': security_FIGURE__8_png,
  '/security/FIGURE\_9.png': security_FIGURE__9_png,
  '/security/FIGURE\_10.png': security_FIGURE__10_png,
  '/security/FIGURE\_1.png': security_FIGURE__1_png,
  '/security/FIGURE\_3.png': security_FIGURE__3_png,
  '/cybench-nowatermark.png': cybench_nowatermark_png,
  '/security/FIGURE\_11.png': security_FIGURE__11_png,
  '/security/FIGURE\_5.png': security_FIGURE__5_png,
  '/security/FIGURE\_12.png': security_FIGURE__12_png,
  '/security/FIGURE\_13.png': security_FIGURE__13_png,
  '/goals-cotra-nowatermark.png': goals_cotra_nowatermark_png,
  '/goals-overview.png': goals_overview_png,
  '/goals-written.png': goals_written_png,
  '/goals-overview2.png': goals_overview2_png,
  '/goals-4o1-nowatermark.png': goals_4o1_nowatermark_png,
  '/goals-4o2-nowatermark.png': goals_4o2_nowatermark_png,
};

export default optimizedImages;
